import styled from "styled-components";
import { checkedInColors } from "./CheckedInStyles";

export const ViewerRoot = styled.div`
    color: ${checkedInColors.black};
`;

export const ViewerBar = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: var(--checked-in-background);
    padding: 18px 20px;
    min-height: 80px;
    h1 { color: var(--checked-in-primary); font-size: 23px; font-weight: 600;
        text-align: center; margin: 0; flex: 1; overflow-wrap: anywhere; }
    > span { width: 44px; }
`;

export const ViewerSection = styled.section`
    padding: 22px 16px;
    @media (min-width: 600px) { padding: 28px; }
`;

export const PostCollection = styled.div<{ $horizontal: boolean }>`
    display: ${p => p.$horizontal ? "flex" : "grid"};
    flex-wrap: nowrap;
    gap: 16px;
    overflow-x: ${p => p.$horizontal ? "auto" : "visible"};
    scroll-snap-type: x mandatory;
    padding: 4px 4px 14px;
    > article { flex: 0 0 min(92%, 440px); scroll-snap-align: start; }
    @media (min-width: 760px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
`;

export const PostCard = styled.article<{ $detail?: boolean }>`
    min-width: 0;
    background: #fff;
    color: ${checkedInColors.black};
    border-radius: ${p => p.$detail ? "0" : "24px"};
    box-shadow: ${p => p.$detail ? "none" : "0 4px 8px #0003"};
    border: ${p => p.$detail ? "0" : "1px solid #eee"};
    overflow: hidden;
`;

export const PostMedia = styled.div<{ $detail: boolean }>`
    width: 100%;
    background: #f5f5f5;
    img, video { display: block; width: 100%; height: ${p => p.$detail ? "auto" : "210px"};
        max-height: ${p => p.$detail ? "60vh" : "280px"}; object-fit: ${p => p.$detail ? "contain" : "cover"}; }
    video { background: #000; }
    button { display: block; width: 100%; padding: 0; border: 0; background: none; cursor: pointer; }
`;

export const PostContent = styled.div`
    padding: 20px;
    h2 { margin: 0; font-size: 22px; font-weight: 600; overflow-wrap: anywhere; }
    p { white-space: pre-wrap; overflow-wrap: anywhere; line-height: 1.5; margin: 12px 0 16px; }
    audio { max-width: 100%; }
`;

export const ViewerMessage = styled.div<{ $error?: boolean }>`
    padding: 24px 20px;
    color: ${p => p.$error ? "#a12e20" : "inherit"};
    line-height: 1.5;
    button { margin-top: 12px; }
`;

export const CheckedInTextArea = styled.textarea`
    display: block;
    width: 100%;
    min-height: 104px;
    resize: vertical;
    padding: 16px;
    border: 1px solid #e5e5e5;
    border-radius: 20px;
    background: ${checkedInColors.white};
    color: ${checkedInColors.black};
    font: inherit;
    font-size: 16px;
    line-height: 1.5;
    box-shadow: 0 3px 6px #0002;
    &::placeholder { color: #777; opacity: 1; }
`;

export const SearchBox = styled.div`
    padding: 16px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
    input { display: block; width: 100%; min-height: 48px; background: #fff;
        color: ${checkedInColors.black}; border: 1px solid #e5e5e5; border-radius: 14px;
        padding: 12px 48px 12px 18px; font-size: 16px; box-shadow: 0 2px 5px #0002; }
    input::placeholder { color: ${checkedInColors.black}; opacity: 1; }
    svg { position: absolute; right: 32px; top: 28px; pointer-events: none; opacity: 0.6; }
`;
